/* Batch 35 · P53-R2 — the "credit" tag next to a vouching row's amount: the row keeps showing the amount as before; the tag
   appears when the GL line is a credit (amount_signed < 0, stored by the server on new rows and by the Maintenance backfill).
   PR 56 review (22-Oct) · R56-1 — the tag is neutral information (the side of the GL line, as the export's "Debit / credit"
   column): the Difference compares the absolute amount, so a credit never implies a difference. A reversal is its OWN tag,
   "Reversal of <voucher>" (``reversal_of``, set by the server), shown in amber. */
import React from "react";
import { useI18n } from "@/contexts/I18nContext";

export function VouchingCreditTag({ item }) {
  const { t } = useI18n();
  const s = item?.amount_signed;
  if (s === null || s === undefined || !(Number(s) < 0)) return null;
  return (
    <span className="ms-1 rounded bg-slate-100 px-1 text-[9px] text-slate-600 dark:bg-slate-800 dark:text-slate-300"
          title={t("b35w2.creditTitle")} data-testid={`vouch-row-credit-${item.id}`}>{t("b35w2.credit")}</span>
  );
}

export function VouchingReversalTag({ item }) {
  const { t, lang } = useI18n();
  const v = String(item?.reversal_of || "").trim();
  if (!v) return null;
  // the voucher number stays left-to-right inside the Arabic text
  const shown = lang === "ar" ? "⁦" + v + "⁩" : v;
  return (
    <span className="ms-1 inline-block rounded bg-amber-100 px-1 text-[9px] font-medium text-amber-900 dark:bg-amber-950/40 dark:text-amber-200"
          title={t("r56.reversalTitle")} data-testid={`vouch-row-reversal-${item.id}`}>
      {t("r56.reversalOf").replace("{voucher}", shown)}
    </span>
  );
}

export default VouchingCreditTag;
